//Sets dimensions
var margin = {top: 0, left: 5, bottom: 5, right: 5},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .65,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);

//Sets the color scale
var color_domain = [50, 100, 150, 200, 250, 300];
var ext_color_domain = [0, 50, 100, 150, 200, 250, 300]; 
var color = d3.scale.threshold() 

.domain(color_domain)
.range(['#ecf8fb', '#d9f1f7', '#c5eaf3', '#b1e2ef', '#9cdbeb', '#4bc6df']);

//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/states.csv")
  .await(ready);

function ready(error, us, maptemplate) {
  if (error) throw error;  
 
  //Pair data with state id
  var dataByFIPS = {};
  maptemplate.forEach(function(d) { dataByFIPS[d.FIPS] = d.perCapitaJobs; });

  //Pair state name with state id
  var stateByFIPS = {};
  maptemplate.forEach(function(d) { stateByFIPS[d.FIPS] = d.state; });

  var div = d3.select("body").append("div")
       .attr("class", "tooltip")
       .style("opacity", 0);

  //Moves selction to front
  d3.selection.prototype.moveToFront = function() {
      return this.each(function(){
        this.parentNode.appendChild(this);
      });
  }; 

  //Moves selction to back
  d3.selection.prototype.moveToBack = function() { 
      return this.each(function() { 
        var firstChild = this.parentNode.firstChild; 
        if (firstChild) { 
          this.parentNode.insertBefore(this, firstChild); 
        } 
      }); 
  };       

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) { return color (dataByFIPS[d.id]); }) 
    .on("mouseover", function(d) {
        //if(d3.select(".gia-chart").node().clientWidth > 450) {
          var right = d3.event.pageX > window.innerWidth / 2;
          var offset = right ? div.node().offsetWidth + 5 : 0;

          var sel = d3.select(this);
            sel.moveToFront();
           
          d3.select(this).transition().duration(200).style({'opacity': 1, 'stroke': '#bdbdbd', 'stroke-width': 2});

          d3.selectAll(".outline").transition().duration(200).style({'opacity': 0});
          
          div.transition().duration(200).style("opacity", 1)
          
          div.html("<span class='bolded'>" + stateByFIPS[d.id] + "</span><br>" + dataByFIPS[d.id] + " jobs per 100,000")
            .style("left", (d3.event.pageX - offset) + "px")
            .style("top", (d3.event.pageY - 25) + "px") 
          //}
        })

        .on("mouseout", function() {
          var sel = d3.select(this);
          sel.moveToBack();
          
          d3.select(this)
            .transition().duration(200)
            .style({'opacity': 1, 'stroke': 'white', 'stroke-width': 1});

          d3.selectAll(".outline").transition().duration(200).style({'opacity': 1});  

          div.transition().duration(200)
            .style("opacity", 0);
        })

  //Select WY
  map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "56" || b.id == "56"; }))
    .attr("d", path)
    .attr("class", "outline");  

  //Select WV
  map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "54" || b.id == "54"; }))
    .attr("d", path)
    .attr("class", "outline");  

  //Select PA
  map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "42" || b.id == "42"; }))
    .attr("d", path)
    .attr("class", "outline");   

  //Select IL
  map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "17" || b.id == "17"; }))
    .attr("d", path)
    .attr("class", "outline");    

  //Select KY
  map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "21" || b.id == "21"; }))
    .attr("d", path)
    .attr("class", "outline");   


  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var w = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = w - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);    

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);
 
  }
}